import { styled, Typography } from "@mui/material";
import Logo from "../../assets/logo.png";

const Wrapper = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "clamp(2rem, 6vw, 5rem)", 
  gap: "clamp(2rem, 6vw, 5rem)", 
  textAlign: "center",
});

const TextContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  maxWidth: "800px",
});

const Title = styled(Typography)({
  letterSpacing: "1px",
  textTransform: "uppercase",
  fontSize: "clamp(1.2rem, 3vw, 2.2rem)", 
});

const Subtitle = styled(Typography)({
  fontWeight: 300,
  color: "rgba(0, 0, 0, 0.7)",
  marginTop: "clamp(6px, 1vw, 10px)",
  fontSize: "clamp(0.6rem, 1.8vw, 1.2rem)",
});

const LogoImg = styled("img")({
  width: "clamp(40px, 10vw, 180px)", 
  height: "auto", 
  opacity: 0.8,
});

const Footer = () => {
  return (
    <Wrapper>
      <TextContainer>
        <Title variant="h3">READY TO TRANSFORM YOUR WALLS?</Title>
        <Subtitle variant="h6">
          Shop our wall photo collection today and bring elegance home.
        </Subtitle>
      </TextContainer>
      <LogoImg src={Logo} />
    </Wrapper>
  );
};

export default Footer;
